import { Component, Input, OnInit, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { JwtHelperService } from "@auth0/angular-jwt";
import { } from "@ngrx/router-store";
import { select, Store } from "@ngrx/store";
import { fetchAuthSession } from "aws-amplify/auth";
import { NGXLogger } from "ngx-logger";
import { filter } from "rxjs";
import { SignInState } from "src/app/components/allusers/signin/signin.model";
import { getSignedInAndMemberCoursesSelected } from "src/app/components/allusers/signin/signin.selector";
import { commonTokenProvider } from "src/main";
import { AuthService } from "../../../services/auth-service/auth.service";
import { FederatedLogin } from "src/app/services/auth-service/base.token.provider";
@Component({
  selector: "app-lti-home",
  templateUrl: "./lti-home.component.html",
  styleUrls: ["./lti-home.component.css"],
  encapsulation: ViewEncapsulation.None
})
export class LtiHomeComponent implements OnInit {
  jwtHelperService: JwtHelperService;
  errorMessage: string;

  currentUserState$ = this.signInStore.pipe(select(getSignedInAndMemberCoursesSelected), filter(val => val !== null && val !== undefined));
  currentUserState: SignInState;

  constructor(
    private signInStore: Store<SignInState>,
    private authService: AuthService,
    private logger: NGXLogger,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {
    this.jwtHelperService = new JwtHelperService();
  }

  async ngOnInit() {
    this.activatedRoute.queryParams.subscribe(async params => {
      this.logger.info(`Query Params - ${JSON.stringify(params)}`);
      await this.ltiLogin(params);

      if (!this.errorMessage) {
        this.currentUserState$.subscribe(user => {
          this.currentUserState = user;
          this.router.navigate(["/courses"]);
        });
      }
    });
  }

  async ltiLogin(params) {
    if (params.token && params.membername) {
      const { sub, exp } = this.jwtHelperService.decodeToken(params.token);
      const now = new Date().getTime() / 1000;
      if (now > exp) {
        this.logger.info(`Token is expired.`);
        return;
      }
      try {
        commonTokenProvider.loadFederatedLogin({
          domain: "login.keystodriving.lti",
          token: params.token,
          username: params.membername,
        } as FederatedLogin);
        const session = await fetchAuthSession();
        this.logger.info(`AMR - ${JSON.stringify(session)}`);
        const { amr } = session.tokens.accessToken.payload;
        this.logger.info(`AMR - ${JSON.stringify(amr)}`);
        if (Array.isArray(amr)) {
          const username = amr[2]
            ? (<string>amr[2]).split(":")
              ? (<string>amr[2]).split(":")[3]
              : ""
            : "";
          if (username) {
            await this.authService.loggedInUser({ username });
          }
        }
      } catch (error) {
        this.logger.error(`Error - ${JSON.stringify(error)}`);
        this.errorMessage = "Unable to log you in, please contact your administrator.";
        return;
      }
    } else if (params.code && params.message) {
      this.logger.info(`Code - ${params.code}, Message - ${params.message}`);
      this.errorMessage = params.message;
      return;
    } else {
      this.logger.info(`No token or membername or code or message found.`);
      this.errorMessage = "Unable to log you in, please contact your administrator.";
      return;
    }
  }

}
